//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CustomTimeline from './CustomTimeline.vue'
import CustomTimelineCard from './CustomTimelineCard.vue'
import TimelineWithIcons from './TimelineWithIcons.vue'

export default {
  components: {
    CustomTimeline,
    CustomTimelineCard,
    TimelineWithIcons,
  },
}
